<template>
  <div>
    <vx-card class="mb-6">
      <infoProgramaAfiliadosMetas :dados="dados"></infoProgramaAfiliadosMetas>
    </vx-card>

    <vx-card>
      <ListProgramaAfiliadosMetas :dados="dados"></ListProgramaAfiliadosMetas>
    </vx-card>
  </div>
</template>

<script>
import service from "../../../services";
import infoProgramaAfiliadosMetas from "../../Includes/infoProgramaAfiliadosMetas";
import ListProgramaAfiliadosMetas from "./../../lists/ListProgramaAfiliadosMetas";

export default {
  components: {
    infoProgramaAfiliadosMetas,
    ListProgramaAfiliadosMetas
  },

  data() {
    return {
      dados: {}
    };
  },

  methods: {
    getDados() {
      this.$vs.loading();
      service
        .getAll("programa-afiliados", {}, "/" + this.$route.params.id)
        .then(res => {
          this.dados = res.data[0];
          this.$vs.loading.close();
        })
        .catch(e => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    }
  },

  mounted() {
    this.getDados();
  }
};
</script>
